import getKhattabatSelectsStore from "../../../../../../stores/khattabat-stores/selects-store";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Messages from "../../../../khattabat-clients/conversation/body/messages";
import SideActions from "../SideActions";
import Comments from "./Comments";
import Et3Margin from "../../../../../../core/et3-ui/ET3Margin";
import getKhattabat101MatchStore from "../../../../../../stores/khattabat-stores/101m-stores";
import getKhattabatSharedMessagingStore from "../../../../../../stores/khattabat-stores/messaging-stores/conversation-messaging-store";

const Conversation = withLiteObserverAndTheme<{
  clientID: number;
  matchID: number;
}>((props) => {
  const { clientID, matchID, theme } = props;
  const { colors } = theme;

  const isConversationMarked =
    getKhattabatSelectsStore().isMarkedConversation(matchID);
  const { conversationID } = getKhattabat101MatchStore(matchID);
  const { isOpened } = getKhattabatSharedMessagingStore(conversationID.get());
  const isOpenedConversation = isOpened.get() === "OPENED";

  return !isOpenedConversation ? null : (
    <ET3Div
      width={1510}
      height={520}
      alignItems={"center"}
      fDirection={"column"}
      style={{}}
      color={""}
      justifyContent={"center"}
      withShadow={false}
      isExtendable={true}
      isScrollable={false}
      onClick={() => {}}
    >
      <ET3Div
        width={1510}
        height={480}
        alignItems={"center"}
        fDirection={"row"}
        style={{}}
        color={""}
        justifyContent={"center"}
        withShadow={false}
        isExtendable={true}
        isScrollable={false}
        onClick={() => {}}
      >
        <ET3Div
          width={1188}
          height={428}
          alignItems={"center"}
          fDirection={"row"}
          style={{
            border: isConversationMarked
              ? `2px solid ${colors.all.green}`
              : "none",
            borderRadius: 20
          }}
          color={""}
          justifyContent={"center"}
          withShadow={false}
          isExtendable={true}
          isScrollable={false}
          onClick={() => {}}
        >
          <Messages conversationID={conversationID.get()} userID={clientID} />
        </ET3Div>
        <SideActions matchID={matchID} />
      </ET3Div>

      <Comments matchID={matchID} clientID={clientID} />
      <Et3Margin top={5} bottom={5} left={0} right={0} />
    </ET3Div>
  );
});

export default Conversation;
